import { observer } from 'mobx-react';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '../../../../../components/Button';
import { Caption } from '../../../../../components/Caption';
import { Card } from '../../../../../components/Card';
import { Checkbox } from '../../../../../components/Checkbox';
import { FormItem, FormLabel, FormLayout } from '../../../../../components/Form';
import { Modal } from '../../../../../components/Modal';
import { PhoneInput } from '../../../../../components/PhoneInput';
import { TextField } from '../../../../../components/TextField';
import { Wrapper } from '../../../../../components/Wrapper';
import { Routes } from '../../../../../constants/Routes';
import { useContext } from '../../../../../hooks/useContext';
import { useTransaction } from '../../../../../hooks/useTransaction';
import { SessionStore } from '../../../../../stores/SessionStore';
import { ProfileStore } from '../../stores/ProfileStore';
import { NameInput } from '../components/NameInput';

export const AccountsNewNameInputCheckup = observer(() => {
  const { push } = useHistory();
  const store = useMemo(() => new ProfileStore(), []);
  const session = useContext(SessionStore.Context);
  const [isRegistering, setIsRegistering] = useState(false);
  const isLegacy = new URLSearchParams(window.location.search).get('type') === 'LEGACY';
  const [doCallback, status] = useTransaction(async () => {
    try {
      await store.register();
      push({ pathname: Routes.Paths.CheckupReservationNew, search: window.location.search });
    } finally {
      setIsRegistering(false);
    }
  });

  const [authStateKnown, setAuthStateKnown] = useState(false);
  const [concent, setConcent] = useState(false);

  const handleConfirmClick = () => {
    doCallback();
  };

  useEffect(() => {
    if (!session.authStateKnown) {
      return;
    }

    const user = session.user?.userEntity;
    if (!user) {
      setAuthStateKnown(true);
      return;
    }

    push({ pathname: Routes.Paths.CheckupReservationNew, search: window.location.search });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.authStateKnown]);

  if (!authStateKnown) {
    return (
      <Modal visible>
        <Card>ユーザー情報を取得しています...</Card>
      </Modal>
    );
  }

  return (
    <Wrapper>
      <Modal visible={isRegistering}>
        <Card>予約情報を登録しています...</Card>
      </Modal>
      <Caption type="header" underline align="center">
        予約情報の登録
      </Caption>
      <FormLayout>
        <FormItem>
          <NameInput
            value={store.name || { sei: '', mei: '' }}
            onChange={v => store.setName(v)}
            errors={store.errors}
          />
        </FormItem>
        {!isLegacy && (
          <FormItem>
            <FormLabel>メールアドレス(任意)</FormLabel>
            <TextField type="email" color="white" value={store.mail} onChange={v => store.setMail(v)} />
            <Caption type="small">予約時にGoogleカレンダー招待をお送りします。</Caption>
          </FormItem>
        )}
        <FormItem>
          <FormLabel required>電話番号</FormLabel>
          <PhoneInput
            color="white"
            value={store.phone}
            onChange={v => store.setPhone(v)}
            error={store.errors.some(e => e.field === 'phone')}
            errors={store.errors}
          />
        </FormItem>
        <FormItem>
          <Checkbox label="TENの利用規約に同意する" checked={concent} onChange={v => setConcent(v.target.checked)} />
          <div>
            <a style={{ textDecoration: 'underline' }} href="/terms" target="_blank" rel="noreferrer">
              利用規約を確認(別タブが開きます)
            </a>
          </div>
        </FormItem>
        <Button
          type="submit"
          block
          onClick={() => {
            setIsRegistering(true);
            handleConfirmClick();
          }}
          disabled={status.running || !store.valid || !concent}
        >
          内容を確認して健康診断の予約へ
        </Button>
      </FormLayout>
    </Wrapper>
  );
});
